export const MILES_DOCUMENTATION_URL = 'https://docs.bymiles.ai';
export const MILES_SUPPORT_EMAIL = 'support@bymiles.ai';

export function hasPaidPlan(planType: string | null | undefined): boolean {
  return Boolean(planType && planType !== 'free');
}
